import API from './'

const menu = {

	/**
	 * Get a list of users.
	 */
	list(params={}, config={})
	{
		let url = API.getUrl(`menus`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get one user details.
	 */
	one(menuId, params={}, config={})
	{
		let url = API.getUrl(`menu/${menuId}`)

		return API.client().get(url, { params, ...config })
	},

}

export default menu